import React from 'react';
import { useRoutes } from 'react-router-dom';
import routes from './routes';
import './App.scss';

function App() {
  const element = useRoutes(routes);
  return <div id={'App'}>{element}</div>;
}

export default App;
